module.exports = __webpack_public_path__ + "static/values-take-ownership-edf3abd84f44d0040fdfb59d6e73f617.svg";